<template>
    <div class="loading-container text-center">
        <v-progress-circular
        :size="50"
        color="primary"
        indeterminate style="margin: 0 auto;">
        </v-progress-circular>
    </div>
</template>
<script>
export default {
  name: 'Loader',
};
</script>
<style scoped>
.loading-container {
  height: calc(100vh - 273px);
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
}
</style>
